import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';
import { AtivoModel } from './AtivoModel';
import { DetalhesAtivoModel } from './DetalhesAtivoModel';
import { GraficoAtivoModel } from './GraficoAtivoModel';

export class RecomendacaoOpcoesModel extends AtivoModel {

    listaRecomendacoesCompra(tipoRecomendacao: String, idCategoria: number, limit: number, offset: number): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoRecomendacao + '/categorias/' + idCategoria + '/compra/' + limit + '/' + offset)
    }

    listaRecomendacoesVenda(tipoRecomendacao: String, idCategoria: number, limit: number, offset: number): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoRecomendacao + '/categorias/' + idCategoria + '/venda/' + limit + '/' + offset)
    }

    listaRecomendacoesEncerradas(tipoRecomendacao: String, idCategoria: number, limit: number, offset: number, filtro: String = ''): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoRecomendacao + '/categorias/' + idCategoria + '/encerradas/' + limit + '/' + offset + (filtro ? '/' + filtro : ''))
    }

    listaRecomendacoesCompraRetrofit(tipoAtivo: String, limit: number, offset: number, filtro: String = ''): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoAtivo + '/' + limit + '/' + offset + (filtro ? '/' + filtro : ''))
        // return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoAtivo + '/compra/' + limit + '/' + offset + (filtro ? '/' + filtro : ''))
    }

    listaRecomendacoesVendaRetrofit(tipoAtivo: String, limit: number, offset: number, filtro: String = ''): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoAtivo + '/' + limit + '/' + offset + (filtro ? '/' + filtro : ''))
        // return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoAtivo + '/venda/' + limit + '/' + offset + (filtro ? '/' + filtro : ''))
    }

    listaRecomendacoesEncerradasRetrofit(tipoAtivo: String, limit: number, offset: number, filtro: String = ''): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + tipoAtivo + '/encerradas/' + limit + '/' + offset + (filtro ? '/' + filtro : ''))
    }

    getAtivoPorId(idAtivo: Number): Promise<PhicubeResponse<DetalhesAtivoModel>> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/' + idAtivo)
    }

    getGraficoAtivoPorId(idAtivo: Number): Promise<PhicubeResponse<GraficoAtivoModel>> {
        return new GatewayService().requestGet('/api/recomendacoes/opcoes/ativo/' + idAtivo + '/grafico')
    }
}